import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SurveysEffects } from '@main-application/survey-creator/effects/surveys.effects';
import * as fromSurveyReducer from '@main-application/survey-creator/reducers/surveys.reducer';

import { SpaceTemplateEffects } from './space-template.effects';
import * as fromSpaceTemplateReducer from './space-template.reducer';
@NgModule({
  declarations: [],
  imports: [
    EffectsModule.forFeature([SpaceTemplateEffects, SurveysEffects]),
    StoreModule.forFeature(fromSpaceTemplateReducer.spaceTemplateFeatureKey, fromSpaceTemplateReducer.reducer),
    StoreModule.forFeature(fromSurveyReducer.surveysFeatureKey, fromSurveyReducer.reducer),
  ],
})
export class SpaceTemplateStoreModule {}
